import {
  Component,
  OnInit,
  SkipSelf,
  Host,
  Optional,
  forwardRef,
  Input,
  Output, EventEmitter
} from '@angular/core';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { TranslateService } from '@ngx-translate/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { Log } from 'src/app/core/console.log';
import { DropdownFormControl } from '../dropdown-form-control';

@Component({
  selector: 'app-input-dp-family-type',
  templateUrl: './input-dp-family-type.component.html',
  styleUrls: ['./input-dp-family-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpFamilyTypeComponent),
      multi: true
    }
  ]
})
export class InputDpFamilyTypeComponent extends DropdownFormControl implements OnInit {
  @Input() label: any;
  @Output() selectFamilyType: EventEmitter<any> = new EventEmitter();
  errors = inputMgsErrs.familyType;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  protected filterSearchItemCustom(search: string, item: DropdownModel): boolean {
    return super.filterSearchItemCustom(search, item)
      || (item.data.code ? item.data.code.search(search) !== -1 : false);
  }

  initDropdownList() {
    this.resetDropdownList();
    this.masterService.getFamilyType().subscribe(result => {
      this.items.push(...result);
      this.findValueFromList(this.value);
      this.setAfterLoadItemDropdown();
    }, error => {
      Log.error(error);
    });
  }

  changeFamilyType(value: any) {
    this.selectFamilyType.emit(value.data);
  }

  resetDropdownList() {
    this.items = new Array<DropdownModel>();
    // this.translate.get('input.dropdown.select.default').subscribe(label => {
    //   this.items.push({ value: null, label: label, data: null });
    // });
  }
}


